/**
 * Hariom ERP - Excel export helper (client-side)
 * Turns an array of plain row objects into a downloaded .xlsx file. Used by
 * Inventory, Production, Sales, Reports, etc. so every "Export/Download"
 * button behaves the same way and saves a real file to the user's device.
 */
import * as XLSX from 'xlsx'

export function exportRowsToExcel(
  rows: Record<string, string | number>[],
  sheetName: string,
  fileName: string,
) {
  const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{ Info: 'No data' }])
  const wb = XLSX.utils.book_new()
  // Excel sheet names max 31 chars.
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31))
  const stamp = new Date().toISOString().slice(0, 10)
  XLSX.writeFile(wb, `${fileName}_${stamp}.xlsx`)
}
